// src/privacy/pages/CookiesPolicy.tsx
import React from "react";
import "./policy-pages.css";

export const CookiesPolicyPage: React.FC = () => {
  return (
    <div className="policy-container">
      <main className="policy-card">
        <header className="policy-header">
          <h1 className="policy-title">Cookie Policy</h1>
          <p className="policy-subtitle">
            This page explains what cookies are, how we use them, and your choices.
          </p>
          <p className="policy-meta">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <section className="policy-section">
          <h2>What are cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website. They help
            the site remember your preferences, enable core functionality, and improve the overall
            experience. Cookies may be set by us (first-party cookies) or by third parties whose
            services we use.
          </p>
        </section>

        <section className="policy-section">
          <h2>How we use cookies</h2>
          <p>We use cookies for the following purposes:</p>

          <div className="policy-grid">
            <div className="policy-panel">
              <h3>Essential cookies (always on)</h3>
              <p>
                Required for security, authentication, and core site functionality (e.g. keeping you
                signed in, preventing fraud, and remembering basic settings). These cookies cannot
                be switched off in our systems.
              </p>
            </div>

            <div className="policy-panel">
              <h3>Analytics cookies (optional)</h3>
              <p>
                Help us understand how visitors interact with the site (e.g. pages visited, time on
                site, errors). We use this information to improve performance and user experience.
              </p>
            </div>

            <div className="policy-panel">
              <h3>Marketing cookies (optional)</h3>
              <p>
                Used to measure and improve marketing campaigns and, where applicable, show relevant
                content. These cookies may be set by advertising partners.
              </p>
            </div>
          </div>
        </section>

        <section className="policy-section">
          <h2>Managing your cookie preferences</h2>
          <p>
            You can accept or reject optional cookies when you first visit the site. You can also
            change your preferences later by opening the cookie settings in the app (or by clearing
            your browser storage for this site).
          </p>
          <p>
            Most browsers also allow you to control cookies through their settings. Please note
            that disabling certain cookies may impact functionality.
          </p>
        </section>

        <section className="policy-section">
          <h2>Third-party cookies</h2>
          <p>
            Some features may rely on third-party services (for example analytics or payment
            providers). These providers may set cookies or similar technologies. Their use of
            cookies is governed by their own policies.
          </p>
        </section>

        <section className="policy-section">
          <h2>Contact</h2>
          <p>
            If you have questions about this Cookie Policy, contact us via the support channel
            listed in the app or on our website.
          </p>
        </section>
      </main>
    </div>
  );
};

export default CookiesPolicyPage;
